import { useMemo } from 'react';
import { UserProfile } from '../types/enums';

/**
 * Identidade do usuário logado, lida de forma centralizada.
 * Fonte única — substitui os `localStorage.getItem('userId')`/`userProfile`
 * espalhados pelos hooks e guards. A UI só esconde; a autorização real é do backend.
 *
 * Obs.: a escrita dessas chaves (login/logout) ainda vive em useLogin/useEmailVerification;
 * centralizá-la é um follow-up.
 */
export interface CurrentUser {
  userId: string | null;
  userName: string | null;
  profile: UserProfile;
  isAdmin: boolean;
  /** Perfil isento de assinatura (DOMINUS ou PARCEIRO). */
  isento: boolean;
}

/** Perfis conhecidos; qualquer outro valor guardado cai no padrão USUARIO. */
const PERFIS: Record<string, UserProfile> = {
  [UserProfile.DOMINUS]: UserProfile.DOMINUS,
  [UserProfile.PARCEIRO]: UserProfile.PARCEIRO,
  [UserProfile.USUARIO]: UserProfile.USUARIO,
};

export function useCurrentUser(): CurrentUser {
  return useMemo(() => {
    const profile = PERFIS[localStorage.getItem('userProfile') ?? ''] ?? UserProfile.USUARIO;
    return {
      userId: localStorage.getItem('userId'),
      userName: localStorage.getItem('userName'),
      profile,
      isAdmin: profile === UserProfile.DOMINUS,
      // DOMINUS e PARCEIRO usam o app sem pagar. É só para a UI — quem corta
      // o acesso de verdade é o backend (402 tratado no axiosConfig).
      isento: profile !== UserProfile.USUARIO,
    };
  }, []);
}

export default useCurrentUser;
